// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { CSSProperties } from 'react';

const colors = {
  bgLight: '#f0faf3',
  border: '#00403E33',
  white: '#fff',
  white80: '#FFFFFF80',
  darkGreen: '#004140',
  darkGreen80: '#004140B2'
} as const;

export const pageWrapperStyle: CSSProperties = {
  width: '100%',
  minHeight: '100vh',
  backgroundColor: colors.bgLight,
  boxSizing: 'border-box'
};

export const contentOuterStyle: CSSProperties = {
  padding: 30
};

export const mainCardContainerStyle: CSSProperties = {
  padding: '10px 30px 20px 30px',
  backgroundColor: colors.white80,
  border: '0.5px solid #00403E1A',
  borderRadius: 20,
  marginTop: 0,
  marginBottom: 24
};

export const flexColumnStyle: CSSProperties = {
  display: 'flex',
  gap: 30,
  justifyContent: 'space-between',
  flexDirection: 'column'
};

export const interviewHeaderRowStyle: CSSProperties = {
  display: 'flex',
  gap: 12,
  alignItems: 'flex-end',
  justifyContent: 'space-between'
};

export const companyRowStyle: CSSProperties = {
  display: 'flex',
  gap: 12,
  alignItems: 'center'
};

export const roleTextWrapperStyle: CSSProperties = {
  lineHeight: '34px',
  padding: '10px 10px 10px 10px'
};

export const introTitleStyle: CSSProperties = {
  fontSize: 18,
  fontWeight: 400,
  color: colors.darkGreen,
  margin: 0,
  lineHeight: 'normal'
};

export const introRoleStyle: CSSProperties = {
  fontSize: 30,
  fontWeight: 600,
  color: colors.darkGreen,
  margin: 0
};

export const timerRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12
};

export const timerBoxStyle: CSSProperties = {
  padding: 8,
  border: '1px solid #00414033',
  borderRadius: 8,
  fontWeight: 600
};

export const endInterviewButtonStyle: CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  background: '#CC0000',
  border: 'none',
  padding: '12px 20px',
  borderRadius: 6,
  color: '#fff',
  cursor: 'pointer'
};

export const welcomeContainerStyle: CSSProperties = {
  padding: 30,
  border: '0.5px solid #00403E1A',
  background: '#fff',
  borderRadius: 20,
  display: 'flex',
  justifyContent: 'space-between',
  gap: 40
};

export const welcomeLeftStyle: CSSProperties = {
  width: '50%'
};

export const welcomeTitleStyle: CSSProperties = {
  fontSize: 28,
  fontWeight: 700,
  color: '#002f2d',
  margin: 0
};

export const welcomeDescStyle: CSSProperties = {
  fontSize: 16,
  fontWeight: 400,
  color: colors.darkGreen80,
  lineHeight: '22px'
};

export const welcomeInfoRowStyle: CSSProperties = {
  display: 'flex',
  gap: 30,
  alignItems: 'flex-start'
};

export const iconInfoRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 12
};

export const infoTitleStyle: CSSProperties = {
  fontSize: 18,
  fontWeight: 600,
  color: '#00403e',
  margin: 0
};

export const infoDescStyle: CSSProperties = {
  fontSize: 16,
  color: '#004140B2',
  marginTop: '4px'
};

// OpenAI Widget container
export const aiContainerStyle: CSSProperties = {
  width: '100%',
  background: colors.white80,
  border: '0.5px solid #00403E1A',
  borderRadius: 16,
  padding: 30,
  display: 'flex',
  flexDirection: 'column'
};
